import React from "react";
import PropTypes from "prop-types";

/**
 * Displays the given strings slash-separated with all but the least displayed
 * as links.
 */
class Breadcrumb extends React.Component {
    render() {
        let linkedPath = [];
        let fullPath = "/";
        if (this.props.pathList.length === 0) {
            linkedPath.push(<b>Home</b>);
        } else {
            linkedPath.push(<a key={fullPath} href={"/"}>Home</a>);
        }
        for (let i = 0; i < this.props.pathList.length; i++) {
            let path = this.props.pathList[i];
            if (i === this.props.pathList.length - 1) {
                linkedPath.push(" > ");
                fullPath += path.toLowerCase();
                const algorithm = this.props.algorithm || "";
                linkedPath.push(<span key={fullPath}><b>{path} {algorithm}</b></span>);
            } else {
                linkedPath.push(" > ");
                fullPath += path.toLowerCase();
                linkedPath.push(<a key={fullPath} href={fullPath}>{path}</a>);
            }
        }
       return (<div id={"breadcrumb"}>{linkedPath}</div>);
    }
}

Breadcrumb.proptypes = {
    pathList: PropTypes.array.isRequired
};

export default Breadcrumb;
